import axios from 'axios';
import config from '../../config';


const baseUrl = config.baseUrl + '/api/perfiles';

const InformacionIndicador = async (municipio,vista) => {
    try {
        const response = await axios.get(`${baseUrl}/datoIndicador`, {
            params: { municipio,vista }
        });
        return {
            status: response.status,
            data: response.data,
        };
    } catch (error) {
        console.error('Error obteniendo las áreas', error);
        throw error;
    }
};
export {
    InformacionIndicador
};